<div class="mb-8 flex flex-wrap items-end justify-between gap-4 sm:mb-10">
  <div class="flex items-center gap-3">
    <span
      class="flex h-10 w-10 items-center justify-center rounded-xl border border-brand-500/20 bg-brand-500/10 text-brand-400"
      aria-hidden="true"
    >
      @switch (icon) {
        @case ('user') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 7.5a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.5 19.5a7.5 7.5 0 0115 0" />
          </svg>
        }
        @case ('briefcase') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6.75 7.5V6A2.25 2.25 0 019 3.75h6A2.25 2.25 0 0117.25 6v1.5M3.75 9.75h16.5v9A1.5 1.5 0 0118.75 20.25H5.25A1.5 1.5 0 013.75 18.75v-9z" />
          </svg>
        }
        @case ('folder') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 7.5A1.5 1.5 0 015.25 6h4.19l1.5 1.5h7.81A1.5 1.5 0 0120.25 9v9a1.5 1.5 0 01-1.5 1.5H5.25A1.5 1.5 0 013.75 18V7.5z" />
          </svg>
        }
        @case ('layers') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 3l8.25 4.5L12 12 3.75 7.5 12 3zm0 9l8.25 4.5L12 21l-8.25-4.5L12 12z" />
          </svg>
        }
        @case ('mail') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5v10.5A1.5 1.5 0 0118.75 18.75H5.25A1.5 1.5 0 013.75 17.25V6.75zm0 0L12 12.75 20.25 6.75" />
          </svg>
        }
        @case ('academic') {
          <svg class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.8">
            <path stroke-linecap="round" stroke-linejoin="round" d="M4.26 10.147a60.44 60.44 0 00-.491 6.347A48.62 48.62 0 0112 20.904a48.62 48.62 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.64 50.64 0 00-2.658-.813A59.9 59.9 0 0112 3.493a59.9 59.9 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.88 50.88 0 0112 13.489a50.88 50.88 0 017.74-3.342" />
          </svg>
        }
      }
    </span>
    <h2 class="text-2xl font-bold tracking-tight text-ink-100 sm:text-3xl">{{ title }}</h2>
  </div>

  @if (actionLabel && actionHref) {
    <a
      [href]="actionHref"
      target="_blank"
      rel="noopener noreferrer"
      class="text-sm font-medium text-brand-400 transition hover:text-brand-300"
    >
      {{ actionLabel }} →
    </a>
  }
</div>
